import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FormVtexComponent } from './components/form-vtex/form-vtex.component';
import { DemoFaComponent } from './components/demo-fa/demo-fa.component';
import { CallbackComponent } from './components/callback/callback.component';
import { FormCheckout2Component } from './components/form-checkout2/form-checkout2.component';
import { FormProcessorBenefitComponent } from './components/form-processor-benefit/form-processor-benefit.component';
import { LandingComponent } from './components/landing/landing.component';
import { AgoraSimulatorControlComponent } from './components/agora-simulator-control/agora-simulator-control.component';
import { SidenavWrapperComponent } from './components/common/sidenav-wrapper/sidenav-wrapper.component';
import { FormCardRegisterComponent } from './components/form-card-register/form-card-register.component';
import { FormPaylinkComponent } from './components/form-paylink/form-paylink.component';
import { IzipayGeneratorComponent } from './components/izipay-generator/izipay-generator';
import { IzipayExcelGeneratorComponent } from './components/izipay-excel-generator/izipay-excel-generator.component';
import { EstilosInyectablesComponent } from './components/estilos-inyectables/estilos-inyectables.component';
import { FormCheckoutReactQrComponent } from './components/form-checkout-react-qr/form-checkout-react-qr.component';
import { FormSavedCardComponent } from './components/form-saved-card/form-saved-card.component';
import { FormSipPayComponent } from './components/form-sip-pay/form-sip-pay.component';

const routes: Routes = [
  { path: 'main', component: LandingComponent },
  {
    path: 'backoffice',
    component: SidenavWrapperComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./components/orders/orders.module').then(
            m => m.OrdersModule
          ),
      },
    ],
  },
  {
    path: 'ordenes',
    component: SidenavWrapperComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./components/orders/orders.module').then(
            m => m.OrdersModule
          ),
      },
    ],
  },
  {
    path: 'vtex',
    component: SidenavWrapperComponent,
    children: [
      { path: '', component: FormVtexComponent }
    ]
  },
  {
    path: 'demo1',
    component: SidenavWrapperComponent,
    children: [
      { path: '', component: DemoFaComponent }
    ]
  },
  {
    path: 'checkout',
    redirectTo: 'checkout2',
    pathMatch: 'full',
  },
  {
    path: 'checkout2',
    component: SidenavWrapperComponent,
    children: [
      { path: '', component: FormCheckout2Component }
    ]
  },
  {
    path: 'checkout-react-qr',
    component: SidenavWrapperComponent,
    children: [
      { path: '', component: FormCheckoutReactQrComponent }
    ]
  },
  {
    path: 'processor-benefit',
    component: SidenavWrapperComponent,
    children: [
      { path: '', component: FormProcessorBenefitComponent }
    ]
  },
  {
    path: 'card-register',
    component: SidenavWrapperComponent,
    children: [
      { path: '', component: FormCardRegisterComponent }
    ]
  },
  {
    path: 'return',
    component: SidenavWrapperComponent,
    children: [
      { path: '', component: CallbackComponent }
    ]
  },
  {
    path: 'agora-simulator-control',
    component: SidenavWrapperComponent,
    children: [
      { path: '', component: AgoraSimulatorControlComponent }
    ]
  },
  {
    path: 'paylink',
    component: SidenavWrapperComponent,
    children: [
      { path: '', component: FormPaylinkComponent }
    ]
  },
  {
    path: 'izipay-generator',
    component: SidenavWrapperComponent,
    children: [
      { path: '', component: IzipayGeneratorComponent }
    ]
  },
  {
    path: 'izipay-excel-generator',
    component: SidenavWrapperComponent,
    children: [
      { path: '', component: IzipayExcelGeneratorComponent }
    ]
  },
  {
    path: 'estilos-inyectables',
    component: SidenavWrapperComponent,
    children: [
      { path: '', component: EstilosInyectablesComponent }
    ]
  },
  {
    path: 'saved-card-pay',
    component: SidenavWrapperComponent,
    children: [
      { path: '', component: FormSavedCardComponent }
    ]
  },
  {
    path: 'sip-pay',
    component: SidenavWrapperComponent,
    children: [
      { path: '', component: FormSipPayComponent }
    ]
  },
  { path: '**', redirectTo: 'main', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
